import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../component/hero/hero";
import Solopreneur from "../component/solopreneur/solopreneur";
// import Capability from "../component/capability/capability";
import HeadingCapability from "../component/heading-capability/heading-capability";
// import MwgEffect049 from "../component/mwg-effect049/mwg-effect049";
import Features from "../component/features/features";
import Form from "../component/form/form";
import RunningText from "../component/running-text/running-text";
import Capability01 from "../component/capability-01/capability-01";
import Capability02 from "../component/capability-02/capability-02";
import Capability03 from "../component/capability-03/capability-03";
import Capability04 from "../component/capability-04/capability-04";
import Capability05 from "../component/capability-05/capability-05";

const LandingPage = () => {
  const location = useLocation();

  useEffect(() => {
    const rawHash = typeof window !== "undefined" ? window.location.hash : location.hash || "";
    const hash = rawHash.replace("#", "").trim();
    if (!hash || !/^solutions-0[1-5]$/.test(hash)) return;

    const scrollToSection = () => {
      const el = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return true;
      }
      return false;
    };

    const delays = [0, 150, 400, 800];
    const timeouts = delays.map((ms) => setTimeout(scrollToSection, ms));
    return () => timeouts.forEach(clearTimeout);
  }, [location.hash]);

  return (
    <main className="landing-main">
      <Hero />
      <Solopreneur />
      <HeadingCapability />
      {/* <MwgEffect049 /> */}
      {/* <Capability /> */}
      <Capability01 />
      <Capability02 />
      <Capability03 />
      <Capability04 />
      <Capability05 />
      <Features />
      <Form />
      <RunningText />
    </main>
  );
};

export default LandingPage;
